import store from '@/store';
import request from '@hb/sharp-request';

import { depositGWUrl } from '@/constant';
import { BannerModelType, BannerSceneEnum } from '@/po/banner';

// 通用http请求配置
const customHttpConfig = {
  baseURL: depositGWUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
  showLoading: undefined,
};

export const getBanners = (
  scence: BannerSceneEnum,
): Promise<BannerModelType[]> => request.postGate(
  'f.user.banner.get',
  {
    scence,
    token: store.state.base.token,
    cityInfoJson: store.state.base.cityInfo,
  },
  customHttpConfig,
);
